import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
  socialLinks = [
    {
      name: 'Email',
      image: 'assets/images/social/gmail.png',
      link: 'mailto:rnagarajan96.official@gmail.com',
      displayName: 'rnagarajan96.official'
    },
    {
      name: 'LinkedIn',
      image: 'assets/images/social/linkedin-circle.png',
      link: 'https://www.linkedin.com/in/rnagarajan96/',
      displayName: 'linkedin.com/in/rnagarajan96'
    },
    {
      name: 'Twitter',
      image: 'assets/images/social/twitter-circle.png',
      link: 'https://twitter.com/rnagarajan96',
      displayName: 'twitter.com/rnagarajan96'
    },
    {
      name: 'Facebook',
      image: 'assets/images/social/facebook-circle.png',
      link: 'https://www.facebook.com/rnagarajan96',
      displayName: 'facebook.com/rnagarajan96'
    }
  ];
  constructor() { }

  ngOnInit(): void {
  }

}
